export const DATE_LOCALE = "ca";

export const PASS_NO_MODIFICADA =
  "E6aqPMaPHxZm6Au4XtWupw!CZ!kgt8o@ZFXh3k!M0DCSUsf18g";
